ChangeBoardPermsView = require 'views/board-menu/change-board-perms-view'

module.exports = class ChangeBoardAddMemberPermsView extends ChangeBoardPermsView
  viewTitleKey: 'add member permissions'
  getTemplate: -> 'board_menu_invitations'
  getPerm: -> 'invitations'



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/change-board-add-member-perms-view.coffee